<template>
  <div
    class="absolute top-0 mx-auto w-1/2 h-full flex justify-center items-center text-center overflow-visible"
  >
    <div class="scan-light" :style="{ bottom: `${progress * 0.75 + 6}%` }"></div>
    <div class="progress text-purple-gradient">{{ progress }}%</div>
  </div>
</template>

<script>
export default {
  name: 'ScanProgress',
  props: {
    progress: Number,
  },
};
</script>

<style lang="scss" scoped>
.progress {
  @apply relative font-medium mx-auto pl-2;
  font-size: 60px;
}
.scan-light {
  @apply absolute;
  width: 100%;
  height: 46px;
  opacity: 0.5;
  border-radius: 20px;
  filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-image: var(--brand-gradient-vertical);
  will-change: bottom;
}
</style>
